import {
    Component,
    HostListener,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { ConfigManagerService } from '../../shared/services/config-manager.service';
import { select, Store } from '@ngrx/store';
import { RootState } from '../../store/store.state';
import { GetUserPermissionsRequest } from '../../utils/store/rbac/rbac.actions';
import { takeUntil } from 'rxjs/operators';

import {
    selectAppLoading,
    selectUserPermissionsExist
} from '../../utils/store/rbac/rbac.selectors';
import {
    // ClearPollingInterval,
    GetAppMaintenanceModeStatusRequest
} from '../../utils/store/common/common.actions';
import { selectMaintenanceModeData } from '../../utils/store/common/common.selectors';
import { BaseAbstractComponent } from '../../shared/base/base-abstract.component';

@Component({
    standalone: false,
    selector: 'q-layout-secure',
    templateUrl: './layout-secure.component.html',
    styleUrls: ['./layout-secure.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LayoutSecureComponent
    extends BaseAbstractComponent
    implements OnInit
{
    version: string;
    businessAppUrl: string;
    isMaintenanceMode: boolean = false;
    maintenanceModeDisplayMssg: string = '';
    userPermissionsReceived: boolean = false;
    isLoading: boolean;

    constructor(
        configManagerService: ConfigManagerService,
        private store: Store<RootState>
    ) {
        super();
        this.version = configManagerService.version;
        this.businessAppUrl = configManagerService.apps.business;
    }

    ngOnInit() {
        this.store
            .pipe(select(selectAppLoading))
            .pipe(takeUntil(this.$destroy))
            .subscribe((isLoading) => (this.isLoading = isLoading));

        this.store
            .pipe(select(selectUserPermissionsExist))
            .pipe(takeUntil(this.$destroy))
            .subscribe(
                (userPermissionsExist) =>
                    (this.userPermissionsReceived = userPermissionsExist)
            );

        this.store
            .pipe(select(selectMaintenanceModeData))
            .pipe(takeUntil(this.$destroy))
            .subscribe((maintenanceModeData) => {
                this.isMaintenanceMode =
                    maintenanceModeData?.maintenanceMode ?? false;
                this.maintenanceModeDisplayMssg =
                    maintenanceModeData?.maintenanceModeDisplayMssg ?? '';
            });

        /**
         * Fetch logged in user's permissions.
         * RBAC [Role Based Access Control] implemented as part of PRD
         * https://quotient.atlassian.net/browse/PROMO-683 and
         * https://quotient.atlassian.net/browse/PROMO-650
         */
        this.store.dispatch(new GetUserPermissionsRequest());

        this.store.dispatch(new GetAppMaintenanceModeStatusRequest());
    }

    preOnDestroy() {
        // this.store.dispatch(new ClearPollingInterval());
    }

    // // To clear maintenance mode polling interval on page refresh or close
    // @HostListener('window:beforeunload', ['$event'])
    // unloadHandler() {
    //     this.store.dispatch(new ClearPollingInterval());
    // }
}
